import Quill from 'quill';

const Inline = Quill.import('blots/inline');

class ButtonBlot extends Inline {
  static create(value) {
    const node = super.create();
    node.setAttribute('href', value.url || '#');
    node.setAttribute('target', value.target || '_blank');
    node.setAttribute('class', 'quill-button');
    node.textContent = value.text || 'Button';
    return node;
  }

  static value(node) {
    return {
      url: node.getAttribute('href'),
      text: node.textContent,
      target: node.getAttribute('target')
    };
  }
}

ButtonBlot.blotName = 'button';
ButtonBlot.tagName = 'a';

export default ButtonBlot;
